if (!customElements.get('product-tab-anchors')) {
    class ProductTabsAnchor extends HTMLElement{
        constructor(){
            super();
            this.anchors = this.querySelectorAll(".tabs__elem");
        }

        connectedCallback(){
            for (let el of this.anchors) {
                let child = el.querySelector("a"),
                    anchor_value = "section"+child.href.substring(child.href.indexOf("#")).replace("#shopify-section-",".section--");

                if(document.querySelector(anchor_value) == null){
                    el.remove(); //doesn't work yet.. needs to be fixed
                }
            }
        }
    }

    customElements.define("product-tab-anchors", ProductTabsAnchor);
}